<template>

    <div>

        <button :id="id" ref="input" v-bind="$attrs" :class="childClass" type="submit" class="btn btn-lg btn-primary text-white" :disabled="form.processing">
            {{ translatedLabel }}
        </button>

        <div class="position-fixed bottom-0 end-0" style="z-index: 100000000">
            <div class="toast text-white bg-primary border-0" :class="{show: form.isDirty}">
                <div class="toast-body">
                    {{ __('Es gibt ungespeicherte Änderungen.') }}
                </div>
            </div>
        </div>

    </div>

</template>


<script>
    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `submit-button-${this._uid}`
                },
            },
            label: {
                type: String,
                default: 'submit',
            },
            childClass: {
                type: String,
            },
            form: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
    }
</script>
